import axios from "axios";

const getProfileDetails = () => {
  return new Promise((resolve) => {
    axios
      .get(`${process.env.REACT_APP_NODE_URL}/profile/view-profile`, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  });
};
const saveNewPasswordHook = (data) => {
  return new Promise((resolve) => {
    axios
      .post(
        `${process.env.REACT_APP_NODE_URL}/profile/validate-old-pwd`,
        data,
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  });
};

const createCompanyDetailsHook = (data) => {
  return new Promise((resolve) => {
    axios
      .post(
        `${process.env.REACT_APP_NODE_URL}/profile/create-company-details`,
        data,
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => console.log(err));
  });
};

const updateCompanyDetailsHook = (data) => {
  return new Promise((resolve) => {
    axios
      .put(
        `${process.env.REACT_APP_NODE_URL}/profile/update-company-details`,
        data,
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => console.log(err));
  });
};

const getCompanyDetailsHook = () => {
  return new Promise((resolve) => {
    axios
      .get(`${process.env.REACT_APP_NODE_URL}/profile/company-details`, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => console.log(err));
  });
};

const UpdatePersonalDetailsHooks = (data) => {
  return new Promise((resolve) => {
    axios
      .put(`${process.env.REACT_APP_NODE_URL}/profile/update-profile`, data, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => console.log(err));
  });
};
export {
  getProfileDetails,
  saveNewPasswordHook,
  createCompanyDetailsHook,
  getCompanyDetailsHook,
  updateCompanyDetailsHook,
  UpdatePersonalDetailsHooks,
};
